import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const MainFooter = ({ copyright }) => {
    const { generalSetting } = useSelector((state) => state?.GeneralSetting);
    
    // Generate copyright text with proper fallbacks
    const copyrightText = React.useMemo(() => {
        // First priority: explicit copyright from props
        if (copyright && copyright !== '') {
            return copyright;
        }
        
        // Second priority: copyright from settings
        if (generalSetting?.site_copyright && generalSetting?.site_copyright !== '') {
            return generalSetting.site_copyright;
        }
        
        // Third priority: generate from company name
        const companyName = 
            generalSetting?.company_name || 
            generalSetting?.site_name || 
            generalSetting?.app_name || 
            'TabanFood';
        
        const currentYear = new Date().getFullYear();
        return `© ${currentYear} ${companyName}, All Rights Reserved`;
    }, [copyright, generalSetting?.site_copyright, generalSetting?.company_name, generalSetting?.site_name, generalSetting?.app_name]);
    
    return (
        <footer className="bg-primary">
            <div className="container">
                <div className="flex flex-col md:flex-row items-center justify-between gap-5 py-8">
                    <p className="text-sm text-white">{copyrightText}</p>
                    <nav className="flex items-center gap-6">
                        <Link className="text-sm capitalize text-white" to={`/menu/page/cookies-policy`}>
                            Cookies Policy
                        </Link>
                        <Link className="text-sm capitalize text-white" to={`/menu/page/about-us`}>
                            About Us
                        </Link>
                        <Link className="text-sm capitalize text-white" to={`/menu/page/contact-us`}>
                            Contact Us
                        </Link>
                    </nav>
                </div>
            </div>
        </footer>
    );
};

export default MainFooter;
